import { render } from "./placeholder.vue?vue&type=template&id=3aa42892&scoped=true"
import script from "./placeholder.vue?vue&type=script&lang=js"
export * from "./placeholder.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=3aa42892&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa42892"]])

export default __exports__